
import React, { Component } from 'react';
import './Style.css';
import '../../../custom.css'
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';
import { Seniority } from './Seniority';

export class MyProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            optional: window.location.search.substring(window.location.search.indexOf('optional')).replace('optional=', ''),
            dataProfile: {},
            isPost: false,
            loading: false,
            seniority: [],
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            },
            goals: []
        }
    }

    componentDidMount() {
        this.getCurrentUser();
        this.GetSeniorityByUserId();
        this.GetGoalByUserId();
    }

    componentDidUpdate() {
        if (document.querySelector(".drop_box")) {

            var elementos = document.querySelectorAll(".drop_box");
            elementos.forEach((a, i) => {

                var buttonFile = a.querySelector("button");
                var input = a.querySelector("input");

                if (buttonFile) {
                    buttonFile.onclick = () => {
                        input.click();
                    };
                }

            })
        }
    }

    async getCurrentUser() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Profile/GetCurrentUser?userId=${this.state.optional}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ dataProfile: data.result });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los planes por tema',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async UpdateProfile() {

        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            body: JSON.stringify(this.state.dataProfile)
        }

        this.setState({ loading: true });

        const response = await fetch('Profile/UpdateProfile', request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ dataProfile: data.result, enableButton: false });
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'la información se ha actualizado correctamente.',
                    Type: 'alert-success',
                    Show: true
                }
            });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'actualizando la información del perfil, inténtelo de nuevo.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async UpdateTeam() {

        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            body: JSON.stringify(this.state.dataProfile)
        }

        this.setState({ loading: true });

        const response = await fetch('Profile/UpdateTeam', request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ dataProfile: data.result, enableButtonTeam: false });
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'la información se ha actualizado correctamente.',
                    Type: 'alert-success',
                    Show: true
                }
            });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'actualizando la información del perfil, inténtelo de nuevo.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    getBase64(file, source) {
        var context = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {

            if (source == 'profile') {
                var model = context.state.dataProfile;
                model.newPhoto = reader.result;
                model.photo = reader.result;
                context.setState({ dataProfile: model, enableButton: true });
            }

            if (source == 'team') {
                var model = context.state.dataProfile;
                model.newPhoto = reader.result;
                model.logo = reader.result;
                context.setState({ dataProfile: model, enableButtonTeam: true });
            }

            if (source == 'photoBuddy') {
                var model = context.state.dataProfile;
                model.NewPhotoBuddy = reader.result;
                model.photoBuddy = reader.result;
                context.setState({ dataProfile: model, enableButton: true });
            }
        };
        reader.onerror = function (error) {
            alert("Error subiendo imagen, por favor inténtelo de nuevo.")
        };
    }

    selectedImage(e, source) {
        if (e.currentTarget.files.length > 0) {
            this.getBase64(e.currentTarget.files[0], source)
        }
    }

    async GetSeniorityByUserId() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Profile/GetSeniorityByUserId?userId=${this.state.optional}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ seniority: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los planes por tema',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetGoalByUserId() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        const response = await fetch(`Letter/GetGoalByUserId?userId=${this.state.optional}`, request);
        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ goals: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando las metas',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    render() {

        return (
            <div className="wrapp-profile row mt-5">

                <div className="col-lg-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/comunidad">Inicio</a></li>
                            {
                                this.state.optional ? <li class="breadcrumb-item active"><a href="/comunidad/pls">Comunidad</a></li> : null
                            }
                            <li class="breadcrumb-item active" aria-current="page">Mi perfil</li>
                        </ol>
                    </nav>
                </div>

                <div className="col-12"><h2 className="align-middle text-center">Mi carta de logros</h2></div>
                <div className="col-12">
                    <h6 className="align-middle text-center">Avance</h6>
                    <div class="progress">
                        {
                            this.state.goals.length > 0 ?
                                <div class="progress-bar" role="progressbar" style={{ "width": `${parseInt(this.state.goals.filter(c => c.goalIsAlready && c.isActive).length * (100 / this.state.goals.filter(c => c.isActive).length))}%` }} aria-valuenow={parseInt(this.state.goals.filter(c => c.goalIsAlready && c.isActive).length * (100 / this.state.goals.filter(c => c.isActive).length))} aria-valuemin="0" aria-valuemax="100">{parseInt(this.state.goals.filter(c => c.goalIsAlready && c.isActive).length * (100 / this.state.goals.filter(c => c.isActive).length))}%</div>
                                :
                                <div class="progress-bar" role="progressbar" style={{ "width": "0%" }} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">0</div>
                        }
                    </div>
                </div>

                <div class="tabs mt-5">
                    <div class="tab-button-outer">
                        <ul id="tab-button">
                            <li><a href="#tab01">Participante</a></li>
                            <li><a href="#tab02">Equipo</a></li>
                        </ul>
                    </div>

                    <div id="tab01" class="tab-contents">
                        <div className="col-lg-12 mt-5">
                         

                                <div className="form-group row col-lg-12">
                                    <div class="card col-lg-6 text-center">
                                        {
                                            !this.state.dataProfile.photo ?
                                                <div class="drop_box">
                                                    <header>
                                                        <h4>Seleccione foto</h4>
                                                    </header>
                                                    <p>Archivos soportados: .jpg, .jpeg, .png, .gif</p>
                                                <input type="file" hidden accept="image/*" id="fileID" style={{ "display": "none" }} onChange={(e) => { this.selectedImage(e, 'profile') }} />
                                                {!this.state.optional ? <button class="btn">Seleccionar foto</button> : null}
                                                </div>
                                                :
                                            <div class="image-is-selected" >
                                                <div className="wrapp-photo">
                                                    <img src={this.state.dataProfile.photo} />
                                                </div>
                                                {
                                                    !this.state.optional ? <input type="button" className="btn btn-danger" value="Eliminar" onClick={(e) => {
                                                        var model = this.state.dataProfile;
                                                        model.photo = '';
                                                        this.setState({ dataProfile: model, enableButton: false })
                                                    }} /> : null
                                                }
                                                </div>
                                        }


                                </div>
                                    <div class="card col-lg-6 text-center">
                                        {
                                            !this.state.dataProfile.photoBuddy ?
                                                <div class="drop_box">
                                                    <header>
                                                        <h4>Foto con el buddy</h4>
                                                    </header>
                                                    <p>Archivos soportados: .jpg, .jpeg, .png, .gif</p>
                                                <input type="file" hidden accept="image/*" id="fileID" style={{ "display": "none" }} onChange={(e) => { this.selectedImage(e, 'photoBuddy') }} />
                                                {!this.state.optional ? <button class="btn">Seleccionar foto</button> : null}
                                                </div>
                                                :
                                                <div class="image-is-selected" >
                                                    <div className="wrapp-photo">
                                                        <img src={this.state.dataProfile.photoBuddy} />
                                                    </div>
                                                {
                                                    !this.state.optional ?
                                                        <input type="button" className="btn btn-danger" value="Eliminar" onClick={(e) => {
                                                            var model = this.state.dataProfile;
                                                            model.photoBuddy = '';
                                                            this.setState({ dataProfile: model, enableButton: false })
                                                        }} /> : null
                                                }
                                                </div>
                                        }


                                    </div>
                                </div>

                            <input disabled={this.state.optional} className="input-no-input name" type="text" value={this.state.dataProfile.fullName} onChange={(e) => {
                                var model = this.state.dataProfile;
                                model.fullName = e.currentTarget.value;
                                this.setState({ dataProfile: model, enableButton: true });

                            }}></input>
                            <div className="text-center">
                                <span>{this.state.dataProfile.email}</span>
                            </div>
                            <div className="mt-3">
                                <textarea disabled={this.state.optional} className="input-no-input text-center" value={this.state.dataProfile.contract} placeholder="Mi contrato es:" onChange={(e) => {
                                    var model = this.state.dataProfile;
                                    model.contract = e.currentTarget.value;
                                    this.setState({ dataProfile: model, enableButton: true });

                                }}></textarea>
                            </div>

                            <label className="mt-3">Mi estiramiento de avanzado</label>
                            <input disabled={this.state.optional} className="input-no-input mt-1" type="text" placeholder="Estiramiento avanzado" value={this.state.dataProfile.advanceStretching} onChange={(e) => {
                                var model = this.state.dataProfile;
                                model.advanceStretching = e.currentTarget.value;
                                this.setState({ dataProfile: model, enableButton: true });

                            }}></input>

                            <label className="mt-3">Estiramiento segundo fin de semana</label>
                            <input disabled={this.state.optional} className="input-no-input mt-1" type="text" placeholder="Estiramiento segundo fin de semana" value={this.state.dataProfile.plStretching} onChange={(e) => {
                                var model = this.state.dataProfile;
                                model.plStretching = e.currentTarget.value;
                                this.setState({ dataProfile: model, enableButton: true });

                            }}></input>

                            <label className="mt-3">Canción que más representa mi proceso</label>
                            <input disabled={this.state.optional} className="input-no-input mt-1" type="text" placeholder="Canción que más representa tu proceso" value={this.state.dataProfile.song} onChange={(e) => {
                                var model = this.state.dataProfile;
                                model.song = e.currentTarget.value;
                                this.setState({ dataProfile: model, enableButton: true });

                            }}></input>

                            <label className="mt-3">Nombre de mi buddy</label>
                            <input disabled={this.state.optional} className="input-no-input mt-1" type="text" placeholder="Nombre del buddy" value={this.state.dataProfile.buddyName} onChange={(e) => {
                                var model = this.state.dataProfile;
                                model.buddyName = e.currentTarget.value;
                                this.setState({ dataProfile: model, enableButton: true });

                            }}></input>

                            <label className="mt-3">Contrato de mi buddy</label>
                            <input disabled={this.state.optional} className="input-no-input mt-1" type="text" placeholder="Contrato del buddy" value={this.state.dataProfile.contractBuddy} onChange={(e) => {
                                var model = this.state.dataProfile;
                                model.contractBuddy = e.currentTarget.value;
                                this.setState({ dataProfile: model, enableButton: true });

                            }}></input>
                        </div>
                        <div className="col-lg-12 mt-5">
                            {
                                !this.state.optional ?
                                    <input type="button" value="Guardar" className="btn btn-primary" disabled={!this.state.enableButton} onClick={() => {
                                        this.UpdateProfile();
                                    }}></input> : null
                            }
                        </div>
                    </div>
                    <div id="tab02" class="tab-contents">
                        <div className="col-lg-12 mt-5">
                            <div className="form-group text-center">
                                <div class="card">
                                    {
                                        !this.state.dataProfile.logo ?
                                            <div class="drop_box">
                                                <header>
                                                    <h4>Seleccione foto</h4>
                                                </header>
                                                <p>Archivos soportados: .jpg, .jpeg, .png, .gif</p>
                                                <input type="file" hidden accept="image/*" id="fileID" style={{ "display": "none" }} onChange={(e) => { this.selectedImage(e, 'team') }} />
                                                {
                                                    !this.state.optional ? <button class="btn">Seleccionar foto</button> : null
                                                }
                                            </div>
                                            :
                                            <div class="image-is-selected" >
                                                <div className="wrapp-photo">
                                                    <img src={this.state.dataProfile.logo} />
                                                </div>
                                                {
                                                    !this.state.optional ?
                                                        <input type="button" className="btn btn-danger" value="Eliminar" onClick={(e) => {
                                                            var model = this.state.dataProfile;
                                                            model.logo = '';
                                                            this.setState({ dataProfile: model, enableButtonTeam: false })
                                                        }} /> : null
                                                }
                                            </div>
                                    }


                                </div>
                            </div>
                            <textarea disabled={this.state.optional} className="input-no-input" value={this.state.dataProfile.vision} placeholder="Visión del equipo" onChange={(e) => {
                                var model = this.state.dataProfile;
                                model.vision = e.currentTarget.value;
                                this.setState({ dataProfile: model, enableButtonTeam: true });

                            }}></textarea>
                            <div className="col-lg-12">
                                {
                                    !this.state.optional ?
                                        <input type="button" value="Guardar" className="btn btn-primary" disabled={!this.state.enableButtonTeam} onClick={() => {
                                            this.UpdateTeam();
                                        }}></input> : null
                                }
                            </div>
                            {
                                !this.state.optional ?
                                    <Seniority></Seniority> : null
                            }
                        </div>
                    </div>
                </div>
                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }} /> : null}
                {this.state.loading ? <Loading /> : null}
            </div>
        );
    }
}
